export const INTEGRATED_LINK_REDIRECTION_TIME = 10;
export const ASSESSMENT_EVALUATION_POLLING_TIME = 5000;

export enum TaskItemStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  EVALUATION_PENDING = 'EVALUATION_PENDING',
  HURDLE_FAILED = 'HURDLE_FAILED',
  HURDLE_PASSED = 'HURDLE_PASSED',
  COMPLETED = 'COMPLETE',
  NOT_STARTED = 'NOT_STARTED',
}

export enum ResponseReuseType {
  FULL_RR = 'FULL_RR',
  PARTIAL_RR = 'PARTIAL_RR',
}

export enum ResponseReuseRouteParam {
  COMPLETE_RR = 'complete-rr',
  FULL_RR = 'full-rr',
  PARTIAL_RR = 'partial-rr',
}
